import { createApi } from "@reduxjs/toolkit/query/react";

import { defaultBaseQuery } from '../../utils/authentication/fetchBaseQuery';
import { transformErrorResponse, transformSuccessResponse } from "../../utils/middleware/responseMiddleware";

export const authApi = createApi({
    baseQuery: defaultBaseQuery,
    endpoints: (builder) => ({
        login: builder.mutation({
            query: (details) => ({
                url: '/Authentication/userLogin',
                method: 'POST',
                body: details,
            }),
            invalidateTags: ['authentication'],
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
    }),
});

export const { useLoginMutation } = authApi;